module.exports = __webpack_public_path__ + "img/heroFormInflate.7a0b6267.svg";